export const iterateTopicMessages = (topic, callback) => {
  if (!topic || typeof callback !== "function") return;

  try {
    if (typeof topic.messages === "function") {
      topic.messages(callback);
      return;
    }

    if (topic._messages) {
      const msgs = topic._messages;

      if (typeof msgs.forEach === "function") {
        msgs.forEach(callback);
        return;
      }

      if (Array.isArray(msgs)) {
        msgs.forEach(callback);
        return;
      }

      if (msgs instanceof Map) {
        msgs.forEach((msg) => callback(msg));
        return;
      }
    }

    if (typeof topic.messageRange === "function" && topic.seq > 0) {
      const low = Math.max(1, topic.seq - 100);
      topic.messageRange(low, topic.seq + 1, callback);
      return;
    }

    if (typeof topic.latestMessage === "function") {
      const latest = topic.latestMessage();
      if (latest) callback(latest);
      return;
    }
  } catch (err) {
    if (process.env.NODE_ENV === "development") {
      console.warn(
        "[tinodeTopicHelper] iterateTopicMessages failed:",
        err?.message,
      );
    }
  }
};

export const countTopicMessages = (topic) => {
  if (!topic) return 0;
  let count = 0;
  iterateTopicMessages(topic, () => count++);
  return count;
};

export const getTopicMessagesArray = (topic) => {
  const result = [];
  iterateTopicMessages(topic, (msg) => {
    if (msg?.seq) result.push(msg);
  });
  return result;
};
